import React from 'react';
import LegalPageLayout, { LegalContactBlock } from './LegalPageLayout';

const TermsOfService = () => (
  <LegalPageLayout
    title="Terms of Service"
    version="Terms of Service Version I"
    effectiveDate="19th Apr 2026"
  >
    <p className="legal-page__intro">
      By accessing or using this User Interface / website, you agree to comply with and be bound by
      the following Terms and Conditions. If you do not agree to these terms, please do not use our
      ui / website.
    </p>

    <h2>1. Use of the User Interface / Website</h2>
    <p>
      You agree to use the ui / site only for lawful purposes and in accordance with these Terms.
      You may not use the User interface / website in any way that could damage, disable,
      overburden, or impair our services or interfere with any other party&apos;s use.
    </p>

    <h2>2. Intellectual Property Rights</h2>
    <p>
      All content, features, and functionality on this ui / site including text, graphics, logos,
      images, audio, video, and software—are the property of{' '}
      <strong>Innovative Info Solutions Pvt Ltd</strong> or its licensors and are protected by
      intellectual property laws.
    </p>
    <p>
      You may not copy, modify, distribute, transmit, display, reproduce, or use any content from
      this ui / site without our prior written consent.
    </p>

    <h2>3. User Content</h2>
    <p>
      If you submit any material (e.g., through contact forms or emails), you grant us a worldwide,
      non-exclusive, royalty-free license to use, reproduce, and publish such content. You are solely
      responsible for your submissions and agree not to post any unlawful or offensive material.
    </p>

    <h2>4. Third-Party Links</h2>
    <p>
      This website may contain links to third-party websites or services that are not owned or
      controlled by <strong>Innovative Info Solutions Pvt Ltd</strong>. We are not responsible for
      the content or privacy practices of these external sites.
    </p>

    <h2>5. Disclaimer of Warranties</h2>
    <p>
      The ui / website and its content are provided on an &ldquo;as-is&rdquo; and
      &ldquo;as-available&rdquo; basis. We do not guarantee that the ui / website will be
      error-free, secure, or continuously available. To the maximum extent permitted by law, we
      disclaim all warranties of any kind.
    </p>

    <h2>6. Limitation of Liability</h2>
    <p>
      In no event shall <strong>Innovative Info Solutions Pvt Ltd</strong>, its directors,
      employees, or affiliates be liable for any indirect, incidental, special, or consequential
      damages arising out of or related to your use of the ui / website.
    </p>

    <h2>7. Indemnification</h2>
    <p>
      You agree to defend, indemnify, and hold harmless{' '}
      <strong>Innovative Info Solutions Pvt Ltd</strong> from and against any claims, liabilities,
      damages, losses, or expenses arising from your use of the ui / site or your violation of these
      Terms.
    </p>

    <h2>8. Termination</h2>
    <p>
      We reserve the right to suspend or terminate your access to the ui / website at any time
      without notice, for any reason, including breach of these Terms.
    </p>

    <h2>9. Governing Law</h2>
    <p>
      These Terms shall be governed by and construed in accordance with the laws of{' '}
      <strong>India</strong>, without regard to conflict of law principles.
    </p>

    <h2>10. Changes to These Terms</h2>
    <p>
      We reserve the right to update or modify these Terms at any time. Any changes will be effective
      immediately upon posting. Your continued use of the ui / website constitutes acceptance of those
      changes.
    </p>

    <h2>11. Contact Information</h2>
    <p>For any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
    <LegalContactBlock />
  </LegalPageLayout>
);

export default TermsOfService;
